var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCameraPermission(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "131px",
    height: "93px",
    viewBox: "0 0 131 93",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.0011728585 0.513385349 100.97477 0.513385349 100.97477 94.3337575 0.0011728585 94.3337575"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.186101833 0.324746718 94.6217141 0.324746718 94.6217141 89.7580188 0.186101833 89.7580188"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Option-2:-Prompt-w/-alert",
    transform: "translate(-672.000000, -422.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(670.432432, 420.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(66.667647, 49.425880) rotate(1.000000) translate(-66.667647, -49.425880) translate(1.167647, 1.425880)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 0.017388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9421844,92.9036104 L18.0014139,94.3312409 C8.95746624,94.5234219 1.46698185,87.3463756 1.27480082,78.3001401 L0.00503331266,18.6714001 C-0.189435586,9.62745245 6.98761069,2.13696806 16.0338463,1.94478703 L82.9723289,0.517156534 C92.0185645,0.324975505 99.5090488,7.50202178 99.7012299,16.5459695 L100.970997,76.1747094 C101.163178,85.220945 93.98842,92.7114294 84.9421844,92.9036104",
    id: "Fill-1",
    fill: "#393F47"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M120.218843,22.3935349 L107.333562,30.2249118 C104.999935,31.6411029 102.334568,32.4189785 99.6051394,32.4784631 L100.273197,63.7765164 L100.776528,63.765077 C103.185655,63.7078803 105.574191,64.2112116 107.752242,65.2361771 L121.653337,71.7749078 C125.943092,73.7996722 130.862011,70.6058065 130.761345,65.8630533 L129.949151,27.699104 C129.843909,22.7664576 124.421659,19.8105303 120.218843,22.3935349",
    id: "Fill-4",
    fill: "#323840"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.04661001,28.9443913 C4.95529631,28.9443913 3.98981543,28.16194 3.7976344,27.0500354 C3.72671045,26.6473704 2.14808057,17.1069551 7.78310288,10.5018761 C11.214907,6.48437748 16.4587036,4.4870675 23.3520541,4.59230949 C24.6172459,4.61061245 25.6261963,5.64930515 25.6078933,6.91449692 C25.5895903,8.17740083 24.509716,9.17719975 23.2879937,9.16804827 C17.8611675,9.07424563 13.7864722,10.5339063 11.2812552,13.4532276 C7.03725746,18.4018891 8.29329775,26.1943723 8.30702497,26.2744477 C8.51522108,27.5167608 7.68014876,28.6995893 6.43554781,28.9100732 C6.30513925,28.9329519 6.1747307,28.9443913 6.04661001,28.9443913",
    id: "Fill-6",
    fill: "#535863"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8755115,8.99028082 C30.6309105,8.99028082 29.6105208,7.9904819 29.5876421,6.74130521 C29.5670513,5.47840131 30.5737138,4.43513287 31.8366177,4.41454204 L39.0777243,4.29099709 C40.2674164,4.22464888 41.3816088,5.2770688 41.4044875,6.5399727 C41.4250783,7.80287661 40.4184158,8.84614505 39.1555119,8.86673587 L31.9166931,8.99028082 L31.8755115,8.99028082 Z",
    id: "Fill-8",
    fill: "#535863"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.724212,36.5543025 C110.957776,36.5543025 110.209643,36.1699404 109.774948,35.4698524 C109.111465,34.3945537 109.443207,32.9852262 110.518505,32.3194562 L116.496708,28.6222593 C117.569719,27.961065 118.979046,28.2905182 119.644816,29.3658168 C120.310586,30.4411154 119.976557,31.850443 118.903546,32.5139251 L112.925344,36.2134099 C112.550133,36.4444847 112.136029,36.5543025 111.724212,36.5543025",
    id: "Fill-10",
    fill: "#535863"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(6.332496, 4.593127)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3412798,11.5925035 C93.144523,7.13344602 91.1792432,3.15484115 88.1340891,0.324746718 L0.186101833,85.3762913 C3.19465008,88.1697798 7.24189103,89.849076 11.6689183,89.7552733 L78.6096888,88.3276428 C79.1702168,88.3162035 79.7238812,88.2750218 80.2683941,88.2086736 C88.5161633,87.115072 94.7986526,79.9723438 94.6179109,71.4591818 L93.3412798,11.5925035 Z",
    id: "Fill-12",
    fill: "#323840",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66.5097359,47.0997788 C66.6996291,55.9492576 59.6781579,63.2750154 50.8286791,63.4626207 C41.9814882,63.650226 34.6557304,56.6310427 34.4658372,47.7815639 C34.2782319,38.934373 41.2974152,31.6086152 50.146894,31.418722 C58.994085,31.2311167 66.3198427,38.2503 66.5097359,47.0997788",
    id: "Fill-15",
    fill: "#F25279"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4219933,49.5965307 C36.8019807,49.5965307 36.2917858,49.100063 36.2780586,48.4777626 C36.1751044,43.7670395 37.5867199,39.8570707 40.3573297,37.171112 C43.0981972,34.5103199 46.9990145,33.2382646 51.6136471,33.476203 C52.245099,33.510521 52.7278395,34.0481703 52.6958093,34.6796223 C52.6614913,35.3087864 52.1375692,35.7846632 51.49239,35.7617845 C47.5298002,35.5444369 44.223829,36.6082962 41.9496868,38.8138023 C39.6480902,41.0467628 38.476701,44.371037 38.565928,48.4274294 C38.5796552,49.0588814 38.0786118,49.5828035 37.4471598,49.5965307 L37.4219933,49.5965307 Z",
    id: "Fill-17",
    fill: "#FC8CAB"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraPermission);
export default __webpack_public_path__ + "static/media/camera-permission.fa52b0b1497b0d6003d16ec8376dc873.svg";
export { ForwardRef as ReactComponent };